module.exports = __webpack_public_path__ + "static/media/TestMt.376ee975.svg";